import { render, staticRenderFns } from "./EditNoteOpen.vue?vue&type=template&id=511e7c44"
import script from "./EditNoteOpen.vue?vue&type=script&lang=js"
export * from "./EditNoteOpen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports